import { render, staticRenderFns } from "./ChevronUpIcon.vue?vue&type=template&id=8dcee984&"
import script from "./ChevronUpIcon.vue?vue&type=script&lang=js&"
export * from "./ChevronUpIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports